import { graphql, useStaticQuery } from '@amazeelabs/gatsby-plugin-operations';
import { SearchPageSettingsQuery } from '@custom/schema';

export const useSearchPageSettings = () => {
  return useStaticQuery(graphql(SearchPageSettingsQuery));
};
